import { getService } from '../utils';

export const getAgentSessionsService = getService('agentSessions');
